// Definiere Clock-Klasse nur wenn sie benötigt wird
if (document.querySelector('.clock')) {
  class Clock {
    constructor(element) {
      this.hands = {
        hour: element.querySelector('.hour-hand'),
        minute: element.querySelector('.minute-hand'),
      }

      this.timeout = null
      this.lastUpdate = null
      this.lastHourAngle = null
      this.lastMinuteAngle = null

      this.start()
    }

    updateHands(hours, minutes) {
      const HOUR_ANGLE = 30
      const MINUTE_ANGLE = 6

      const hourAngle = ((hours % 12) + minutes / 60) * HOUR_ANGLE
      const minuteAngle = minutes * MINUTE_ANGLE

      if (this.lastHourAngle !== hourAngle) {
        this.hands.hour.style.transform = `translate(-50%, 0) rotate(${hourAngle}deg)`
        this.lastHourAngle = hourAngle
      }

      if (this.lastMinuteAngle !== minuteAngle) {
        this.hands.minute.style.transform = `translate(-50%, 0) rotate(${minuteAngle}deg)`
        this.lastMinuteAngle = minuteAngle
      }
    }

    update() {
      const now = new Date()
      const currentMinute = now.getMinutes()

      if (this.lastUpdate !== currentMinute) {
        this.updateHands(now.getHours(), currentMinute)
        this.lastUpdate = currentMinute
      }

      const nextMinute = new Date()
      nextMinute.setMinutes(currentMinute + 1, 0, 0)
      const delay = nextMinute - now

      this.timeout = setTimeout(() => {
        this.update()
      }, delay)
    }

    start() {
      this.update()
    }

    destroy() {
      if (this.timeout) {
        clearTimeout(this.timeout)
        this.timeout = null
      }
    }
  }

  // Initialisiere die Uhr nur wenn das DOM bereit ist
  function initClock() {
    const clockElement = document.querySelector('.clock')
    if (clockElement) {
      return new Clock(clockElement)
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initClock)
  } else {
    initClock()
  }
}
